/**
 * Handle validation and processing of the enquiry form
 *
 */

var initializeForm = function() {

    var $form = $('.form_enquiry');
    if ($form.length === 0) {
        return;
    }

    console.log('initializeForm()');

    var $form_wrapper = $form.parent('.form_parent'),
        url = $form.attr('action'),
        hasError = false,
        data = {},

        // csrf
        $tokenInputField = $form.find('#token_enquiry'),
        postTokenName = $tokenInputField.attr('name'),
        postTokenValue = $tokenInputField.val(),

        // form fields
        $first_name     = $form.find('[name=first_name]'),
        $last_name      = $form.find('[name=last_name]'),
        $email          = $form.find('[name=email]'),
        $phone          = $form.find('[name=phone]'),
        $address        = $form.find('[name=address]'),
        $description    = $form.find('[name=description]'),
        $names_         = $form.find('[name=names_]'),
        $enquiry_form   = $form.find('[name=enquiry_form]');

    $form.on('submit', function(event) {
        event.preventDefault();

        $form.find('.input').prop("disabled", true);
        $form.find('.error').remove();
        $form.find('.field_error').removeClass('field_error');
        hasError = false;

        $form.find('.submit').addClass('loading');

        if ($first_name.val() === '') {
            hasError = true;
            $first_name.addClass('field_error');
            $first_name.after("<span class='error'>Field is required</span>")
        }

        if ($last_name.val() === '') {
            hasError = true;
            $last_name.addClass('field_error');
            $last_name.after("<span class='error'>Field is required</span>")
        }

        if (!isValidEmail($email.val())) {
            hasError = true;
            $email.addClass('field_error');
            $email.after("<span class='error'>Please, enter valid email</span>")
        }

        if (hasError) {
            $form.find('.input').prop("disabled", false);
            $form.find('.submit').removeClass('loading');
            return false;
        }

        data = {
            first_name:     $first_name.val() || '',
            last_name:      $last_name.val() || '',
            email:          $email.val() || '',
            phone:          $phone.val() || '',
            address:        $address.val() || '',
            description:    $description.val() || '',
            names_:         $names_.val() || '',
            enquiry_form:   $enquiry_form.val() || ''
        };

        $.ajax({
            type: "post",
            beforeSend: function (request) {
                request.setRequestHeader("X-" + postTokenName, postTokenValue);
            },
            url: url,
            data: data,
            dataType: 'json'
        })
            .done(function(data) {

                console.log('Form result: ', data);

                if (data.error) {
                    // handle php validation error

                    $form.find('.error').remove();
                    $form.find('.field_error').removeClass('field_error');

                    $.each(data.errors, function(field, msg) {
                        var $field = $('#' + field);
                        $field.addClass('field_error');
                        $field.after("<span class='error'>" + msg + "</span>");
                    });

                } else {
                    // success

                    if (data.message) {
                        $form_wrapper.slideUp(400, function() {
                            $form_wrapper.html(data.message);
                            $form_wrapper.slideDown(300);
                        });
                    }
                }

            })
            .fail(function (jqXHR, textStatus) {
                console.log('ajax failed', textStatus);
            })
            .always(function () {
                $form.find('.input').prop("disabled", false);
                $form.find('.submit').removeClass('loading');
            });
    });
};

$(function() {
    "use strict";

    initializeForm();
});

